import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const Privateroute = ({ allowedRoles }) => {
  const token = window.localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const isLoggedIn = !!token;

  if (!token) {
    return <Navigate to="/" />;
  }

  // if (allowedRoles && !allowedRoles.includes(role)) {
  //   if (role == "transaction_cordinator") {
  //     return <Navigate to="/deals-assigned" replace />;
  //   } else {
  //     return <Navigate to="/dashboard" replace />;
  //   }
  // }

  return <Outlet />;
};

export default Privateroute;
